import { Box, TextField } from "@mui/material";
import ErrorHelper from "./ErrorWrapper";
import Flex from "./Flex";
import Text from "./Text";

const SWATCH_HEIGHT = "40px";

interface ColorPickerProps {
  value?: string;
  onChange?: (color: string) => void;
  label?: string;
  required?: boolean;
  error?: string | boolean;
  disabled?: boolean;
  placeholder?: string;
}

const ColorPicker = ({
  value = "#000000",
  onChange,
  label,
  required = false,
  error,
  disabled = false,
  placeholder = "Select color",
}: ColorPickerProps) => {
  const handleColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newColor = e.target.value;
    onChange?.(newColor);
  };

  return (
    <Flex flexDirection="column" width="100%">
      {label && (
        <Text mb="10px" fontSize="12px" fontWeight={500}>
          {label}
          {required && (
            <Text component="span" color="error">
              {" "}
              *
            </Text>
          )}
        </Text>
      )}

      <ErrorHelper error={error}>
        <Flex gap={2} alignItems="center">
          <Box
            sx={{
              position: "relative",
              width: "60px",
              height: SWATCH_HEIGHT,
              border: error ? "1px solid #d32f2f" : "1px solid #ccc",
              borderRadius: "4px",
              overflow: "hidden",
              backgroundColor: value,
              cursor: disabled ? "not-allowed" : "pointer",
              opacity: disabled ? 0.6 : 1,
              flexShrink: 0,
            }}
          >
            <input
              type="color"
              value={value}
              onChange={handleColorChange}
              disabled={disabled}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: "none",
                cursor: "pointer",
                opacity: 0,
              }}
            />
          </Box>

          <TextField
            fullWidth
            value={value}
            onChange={(e) => {
              const newColor = e.target.value;
              onChange?.(newColor);
            }}
            placeholder={placeholder}
            disabled={disabled}
            error={!!error}
            sx={{
              "& .MuiInputBase-input": {
                fontSize: "14px",
              },
              "& .MuiOutlinedInput-root": {
                height: SWATCH_HEIGHT,
              },
            }}
          />
        </Flex>
      </ErrorHelper>
    </Flex>
  );
};

export default ColorPicker;
